import { DeviceMode, isNodeV2, notEmpty } from '@vedalib/editor'
import * as R from 'ramda'

import { getNodeWithFullChildren } from 'components/Editor/EditorContext/selectors/block'
import { notify } from 'components/uiKit/Notification'
import { NotificationType } from 'components/uiKit/Notification/types'
import { fullMergeNodeStyle, getBlock, getSelectedNodeIds } from 'services/Store/Project/selectors'
import { setUserPreferencesItems } from 'services/Store/Users/reducer'
import { selectUserPreferences } from 'services/Store/Users/selectors'
import store from 'services/Store/store'
import { t } from 'services/Translation'

import { remapComplexNode } from '../Picker/complexNodes'
import { getNodeLabel } from '../getNodeLabel'

export const onSaveAsset = async (event?: React.SyntheticEvent | KeyboardEvent) => {
  const state = store.getState()
  const projectState = state.project
  const preferences = selectUserPreferences(state).nodesV2
  const dispatch = store.dispatch
  const block = getBlock(projectState)
  const selectedNodes = getSelectedNodeIds(projectState)
  const children = selectedNodes.map((id) => block?.schema.nodes[id]).filter(isNodeV2)
  const node = children.length === 1 ? children[0] : null

  if (block && node) {
    event?.preventDefault()
    const label = getNodeLabel(block, node, fullMergeNodeStyle(block, node, DeviceMode.desktop))
    const [root, ...nodes] = getNodeWithFullChildren(block, node.id).filter(isNodeV2)
    const elementIds = [root, ...nodes].map((node) => (isNodeV2(node) ? node.elementId : null))
    const elements = R.pick(elementIds.filter(notEmpty), block.elements)
    const remapped = remapComplexNode({
      root: { ...root, label },
      nodes: R.indexBy(R.prop('id'), nodes),
      elements,
    })

    const str = JSON.stringify(remapped)
    dispatch(
      setUserPreferencesItems({ nodesV2: { ...(preferences || {}), [remapped.root.id]: str } }),
    )
    notify({ type: NotificationType.success, message: t('notify.node.copied') })
  }
}
